import * as S from "./styles";

export const TextContent = ({ children }) => {
  return <S.TextContent>{children}</S.TextContent>;
};
